export default __webpack_public_path__ + "static/media/DMSans-Bold.da49214b.ttf";